<gatewee-pix-keys
  [pixKeys]="pixKeys"
  [actions]="pixKeyActions"
  [breadcrumb]="breadcrumb"
  [title]="'features.pixKeys.title'"
  [titlePath]="'features.pixKeys.titlePath'"
  [page]="page"
  [pageSize]="pageSize"
  [total]="total"
  (pageChange)="onPageChange($event)"
></gatewee-pix-keys>
